// extracted by mini-css-extract-plugin
module.exports = {"form":"form--PIoEV","text":"text--oN_3C"};